"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const TaskPage_1 = require("../../base/TaskPage");
const PromotionSection_1 = require("./PromotionSection");
const constants_1 = require("../../../../tasks/constants");
const helpers_1 = require("./helpers");
const MarginWrapper_1 = require("../../../components/margin/MarginWrapper");
const Spacer_1 = require("../../../components/spacer/Spacer");
const HelpLink_1 = require("../../../components/help-link/HelpLink");
const constants_2 = require("../../../../entities/contracts/constants");
const IconListItem_1 = require("../../../components/icon-list-item/IconListItem");
const autosave_1 = require("../../../../hooks/autosave");
const promotionOpportunities_1 = require("../../../../hooks/promotionOpportunities");
exports.default = (props) => {
    const { property } = (0, autosave_1.useAutoSaveProperty)(props.propertyId);
    const { promotionsForProperty, update, viewState, lastSaved, getterError, updaterError } = (0, autosave_1.useAutoSavePromotion)(props.propertyId);
    const { promotionOpportunities: availablePromotions } = (0, promotionOpportunities_1.usePromotionOpportunities)(props.propertyId);
    const renderablePromotions = (0, helpers_1.getRenderablePromotions)(promotionsForProperty !== null && promotionsForProperty !== void 0 ? promotionsForProperty : [], availablePromotions !== null && availablePromotions !== void 0 ? availablePromotions : []);
    const { lhsChannels, rhsChannels } = Object.keys(renderablePromotions).reduce((all, curr, idx) => {
        if (idx % 2 === 0) {
            all.lhsChannels.push(curr);
        }
        else {
            all.rhsChannels.push(curr);
        }
        return all;
    }, { lhsChannels: [], rhsChannels: [] });
    console.log(`Have ${promotionsForProperty === null || promotionsForProperty === void 0 ? void 0 : promotionsForProperty.length} selected promotions`);
    return React.createElement(TaskPage_1.TaskPage, { task: constants_1.Tasks.PROMOTIONS, property: property, viewState: viewState, lastSaved: lastSaved, getterError: getterError, updaterError: updaterError },
        React.createElement(MarginWrapper_1.MarginWrapper, null,
            React.createElement(IconListItem_1.IconListItem, { icon: "circleStar", display: "primary" }, "Promotions will be applied to your overall pricing rate before commission for all upcoming pricing periods."),
            React.createElement(Spacer_1.Spacer, { spacing: "smallest" }),
            React.createElement(IconListItem_1.IconListItem, { icon: "circleStar", display: "primary" }, "You are able to use more than one promotion simultaneously."),
            React.createElement(Spacer_1.Spacer, { spacing: "smallest" }),
            React.createElement(IconListItem_1.IconListItem, { icon: "circleStar", display: "primary" }, "Promotions and discounts are applied per property, not account."),
            React.createElement(Spacer_1.Spacer, null),
            React.createElement(HelpLink_1.HelpLink, { to: "https://travelnest.freshdesk.com/support/solutions/articles/101000396989-promotions-and-discounts" }, "Before applying promotions please read this guide.")),
        React.createElement(Spacer_1.Spacer, null),
        React.createElement(TaskPage_1.TaskLayout, null,
            React.createElement(TaskPage_1.TaskColumn, { width: 50, key: 'promotion-column-lhs' }, lhsChannels.map((ch) => {
                var _a;
                const channelName = constants_2.CHANNEL_FRIENDLY_NAMES[ch];
                const channelsPromotions = (_a = renderablePromotions[ch]) !== null && _a !== void 0 ? _a : [];
                return React.createElement(PromotionSection_1.PromotionSection, { id: ch, title: channelName, promotions: channelsPromotions, onCheckboxClick: (selectedPromotion) => update((0, helpers_1.updatePromotion)(props.propertyId, promotionsForProperty !== null && promotionsForProperty !== void 0 ? promotionsForProperty : [], selectedPromotion)) });
            })),
            React.createElement(TaskPage_1.TaskColumn, { width: 50, key: 'promotion-column-rhs' }, rhsChannels.map((ch) => {
                var _a;
                const channelName = constants_2.CHANNEL_FRIENDLY_NAMES[ch];
                const channelsPromotions = (_a = renderablePromotions[ch]) !== null && _a !== void 0 ? _a : [];
                return React.createElement(PromotionSection_1.PromotionSection, { id: ch, title: channelName, promotions: channelsPromotions, onCheckboxClick: (selectedPromotion) => update((0, helpers_1.updatePromotion)(props.propertyId, promotionsForProperty !== null && promotionsForProperty !== void 0 ? promotionsForProperty : [], selectedPromotion)) });
            }))));
};
//# sourceMappingURL=PromotionsPage.js.map